import React, { createContext, useContext, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { ProgramIntakeDetails, useIntakeDetails } from '../data/useIntakeDetails';

export interface IntakeDetails {
  intake: ProgramIntakeDetails | undefined;
  isLoadingIntake: boolean;
  intakeError: unknown;
  isIntakeError: boolean;
}

const intakeDetailsContext = createContext<IntakeDetails | undefined>(undefined);

export const IntakeDetailsContextProvider = ({ children }: { children: React.ReactNode }) => {
  const { id } = useParams() as { id: string };
  const { intake, isLoadingIntake, intakeError, isIntakeError } = useIntakeDetails(id);

  const value = useMemo(
    () => ({
      intake,
      isLoadingIntake,
      intakeError,
      isIntakeError,
    }),
    [intake, isLoadingIntake, intakeError, isIntakeError]
  );

  return <intakeDetailsContext.Provider value={value}>{children}</intakeDetailsContext.Provider>;
};

export const useIntakeDetailsContext = () => {
  const context = useContext(intakeDetailsContext);
  if (!context) {
    throw new Error('useIntakeDetailsContext must be used within IntakeDetailsContextProvider');
  }
  return context;
};
